// extracted by mini-css-extract-plugin
module.exports = {"image":"AnimatedImage--image--1yEES"};